import React from 'react';
import BrandSymbol from '@/components/BrandSymbol';
const kinds={farm:'farm',livestock:'livestock',nursery:'nursery',association:'community',public_body:'public',park:'parks',botanical_garden:'garden',private:'citizen',professional:'professional'};
export default function SubjectSymbol({type='farm',...props}) {return <BrandSymbol kind={kinds[type] || 'citizen'} {...props}/>;}
